import { useTranslation } from 'react-i18next';

import {
  PaginatedCommandDialog,
  PaginatedCommandDialogProps,
} from '@/modules/common/components/organisms/paginated-command-dialog';
import { IntegrationProviderDTO } from '@/modules/common/types/dto/response/integration-response';

import { hasQuickBooksIntegration } from '../utils/generate-entities.utils';

export interface BillingEntityCandidate {
  id: number;
  connectedIntegrations: IntegrationProviderDTO[];
}

export type AddCustomBillingEntityCommandProps<T extends BillingEntityCandidate> = Omit<
  PaginatedCommandDialogProps<T>,
  'getItemWarning'
>;

/**
 * Picker for a project / team member to include in a generate table. Adds the one rule both
 * screens share on top of the generic dialog: an entity without a QuickBooks link is listed with
 * a warning but cannot be picked, mirroring the table where such rows have a disabled checkbox.
 */
export function AddCustomBillingEntityCommand<T extends BillingEntityCandidate>(
  props: AddCustomBillingEntityCommandProps<T>
) {
  const { t } = useTranslation('common');

  return (
    <PaginatedCommandDialog
      {...props}
      getItemWarning={item =>
        hasQuickBooksIntegration(item.connectedIntegrations)
          ? null
          : t('generateEntities.notConnectedToQuickBooks')
      }
    />
  );
}
